<app-header *ngIf="showFooterHeader"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="showFooterHeader"></app-footer>
<img *ngIf="!maintenanceMode" src="/assets/images/commons/mail-icon.svg" alt="Contacto" class="email-icon"
    [routerLink]="getRouterLink('Contact')">
<img *ngIf="!maintenanceMode" src="/assets/images/commons/up-icon.svg" alt="Principio de página" class="goup-icon" (click)="goUp()">
